import React, {useEffect, useState} from 'react';
import {Col} from "react-bootstrap";
import {getGWList} from "../api/apiClient";
import PopUp from "../components/popUp/PopUp";
import JurisdictionFacilitySearchBox from "../components/searchBoxs/JurisdictionFacilitySearchBox";
import TableConfGW from "../components/tables/TableConfGW";
import ConfGwDetail from "./subPages/ConfGwDetail";

const ConfGateway = ({
                       propAuth = undefined,
                     }) => {
  /* pagination을 위한 state */
  const [listPageSize, setListPageSize] = useState(15);
  const [tableList, setTableList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  // 검색 조건
  const [searchParam, setSearchParam] = useState({
    dist_cd: '',
    fclty_nm: '',
  });
  // 검색 버튼 클릭했는지
  const [isSearch, setIsSearch] = useState(true);

  /* 게이트웨이 목록 갱신 */
  const updateList = () => {
    getGWList(currentPage, listPageSize,
        searchParam.dist_cd, searchParam.fclty_nm)
        .then((res) => {
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const getExportData = () => {
    // excel pdf를 위함.
    return getGWList(currentPage, listPageSize, searchParam.dist_cd, searchParam.fclty_nm);
  }

  useEffect(() => {
    setIsSearch(false);
  }, []);

  useEffect(() => {
    updateList();
  }, [isSearch, currentPage, listPageSize]);

  /* 팝업을 위한 state */
  const [openPopup, setPopup] = useState({isVisible: false, gtwyNo: 0});

  const closePopup = () => {
    setPopup({isVisible: false, gtwyNo: 0});
  }

  return (
      <>
        <PopUp
            // propTitle={'게이트웨이 정보'}
            propTitle={!openPopup.gtwyNo ? '게이트웨이 등록' : '게이트웨이 수정'}
            propShow={openPopup.isVisible}
            setShow={closePopup}
        >
          <ConfGwDetail
              propGwID={openPopup.gtwyNo}
              setShow={closePopup}
              updateList={updateList}
          />
        </PopUp>

        <Col md={12} className={"search-container py-2"}>
          <JurisdictionFacilitySearchBox
              searchParam={searchParam}
              setSearchParam={setSearchParam}
              updateList={updateList}
              setCurrentPage={setCurrentPage}
          />
        </Col>
        <Col md={12} className={"table-container mt-3 py-2"}>
          <TableConfGW
              setOpenLayer={setPopup}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              listPageSize={listPageSize}
              setListPageSize={setListPageSize}
              total={total}
              tableList={tableList}
              updateList={updateList}
              getFullData={getExportData}
              setIsSearch={setIsSearch}
              searchParam={searchParam}
              setSearchParam={setSearchParam}
              setTableList={setTableList}
              setTotal={setTotal}
              propAuth={propAuth}
          />
        </Col>
      </>
  );
};

export default ConfGateway;
